// src/app/Router.tsx
import {lazy} from "react";
import {createBrowserRouter} from "react-router-dom";
import DrawerLayout from "@app/layout/drawer-layout";
import AuthGuardLayout from "@app/layout/auth-guard-layout";
// 진입 화면(로그인)·404·레이아웃은 즉시 로드(첫 페인트 지연 방지)
import LoginPage from "@pages/login/ui/LoginPage";
import NotFoundPage from "@pages/not-found";
// 최상위 미매칭 경로: link.ridefload.com 딥링크 착지(앱 열기). 그 외 호스트는 내부에서 NotFound 렌더.
import OpenAppPage from "@pages/open-app/ui/OpenAppPage";
import RouteError from "@app/layout/route-error";

// /home 하위 페이지는 라우트 단위로 지연 로드(별도 청크) — 메인 번들에서 분리.
// Suspense 경계와 청크 로드 실패 처리는 DrawerLayout 의 <Outlet/> 을 감싼다.
const DashboardPage = lazy(() => import("@pages/dashboard/ui/DashboardPage"));
const UserPage = lazy(() => import("@pages/user/ui/UserPage"));
const BikeOverViewPage = lazy(() => import("@pages/device/bike-overview/ui/BikeOverViewPage"));
const HubOverViewPage = lazy(() => import("@pages/device/hub-overview/ui/HubOverViewPage"));
const HubMapPage = lazy(() => import("@pages/hub-map/ui/HubMapPage"));
const NowUseBikesPage = lazy(() => import("@pages/device/now-use-bikes/ui/NowUseBikesPage"));
const BikeAssetPage = lazy(() => import("@pages/loss-asset/bike-asset/ui/BikeAssetPage"));
const StationAssetPage = lazy(() => import("@pages/loss-asset/station-asset/ui/StationAssetPage"));
const DefectiveBikesPage = lazy(() => import("@pages/loss-asset/defective-bikes/ui/DefectiveBikesPage"));
const UsageHistoryPage = lazy(() => import("@pages/usage-history/ui/UsageHistoryPage"));
const UsageAnalyticsPage = lazy(() => import("@pages/usage-analytics/ui/UsageAnalyticsPage"));
const RevenuePage = lazy(() => import("@pages/financials/revenue/ui/RevenuePage"));
const TempMapUpload = lazy(() => import("@pages/temp-map/ui/TempMapUpload"));
const TempMap = lazy(() => import("@pages/temp-map/ui/TempMap"));


export const router = createBrowserRouter([
    {
        path: "/",
        element: <LoginPage/>, // 최상위 로그인 페이지
        errorElement: <RouteError/>, // [E3] 로그인 렌더 크래시 fallback
    },
    {
        path: "/home/*",
        element: (
            <AuthGuardLayout>
                <DrawerLayout/>
            </AuthGuardLayout>
        ), // 공통 레이아웃 (Drawer)
        errorElement: <RouteError/>, // [E3] AuthGuard/DrawerLayout/하위 페이지 렌더 크래시 fallback
        children: [
            {
                path: "dashboard",
                element: <DashboardPage/>,
            },
            {
                path: "user",
                element: <UserPage/>,
            },
            {
                path: "bike-overview",
                element: <BikeOverViewPage/>,
            },
            {
                path: "hub-overview",
                element: <HubOverViewPage/>,
            },
            {
                path: "hub-map",
                element: <HubMapPage/>,
            },
            {
                path: "now-use-bikes",
                element: <NowUseBikesPage/>,
            },
            {
                path: "bike-asset",
                element: <BikeAssetPage/>,
            },
            {
                path: "station-asset",
                element: <StationAssetPage/>,
            },
            {
                path: "defective-bikes",
                element: <DefectiveBikesPage/>,
            },
            {
                path: "usage-histories",
                element: <UsageHistoryPage/>,
            },
            {
                path: "usage-analytics",
                element: <UsageAnalyticsPage/>,
            },
            {
                path: "revenue",
                element: <RevenuePage/>,
            },
            {
                path: "upload-map",
                element: <TempMapUpload/>,
            },
            {
                path: "temp-map",
                element: <TempMap/>,
            },
            // 404 처리 추가
            {
                path: "*",
                element: <NotFoundPage/>,
            },
        ],
    },
    // 최상위 미매칭: link.ridefload.com 은 딥링크 착지(앱 열기), 그 외 호스트는 404.
    {
        path: "*",
        element: <OpenAppPage/>,
        errorElement: <RouteError/>, // [E3]
    },
]);
